import Main from './Main.jsx';

export default Main;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/index.js